var map = {
	"./Credente_High.avif": 95346,
	"./Credente_High.png": 21863,
	"./Predicatore_High.avif": 84729,
	"./Predicatore_High.png": 47189,
	"./Radio_High.avif": 23625,
	"./Radio_High.png": 45034,
	"./Verdi_High.avif": 52004,
	"./Verdi_High.png": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6563;